import styled from '@emotion/styled';
import {CollapsibleTrigger} from '@radix-ui/react-collapsible';

export const Trigger = styled(CollapsibleTrigger)`
  padding: 0;
  align-self: flex-end;
  margin: 0 4px 4px 0;
  justify-content: space-between;

  &:hover,
  &:active {
    background: transparent !important;
  }

  &:focus-visible {
    outline-offset: 2px;
  }
`;
